<template>
  <v-container>
    <AppLoadingPage v-if="$apollo.queries.event.loading || !event.id" />
    <template v-else>
      <div class="mb-5">
        <EventInfoFields :event="event">
          <template #label><h2 aria-hidden="true"></h2></template>
        </EventInfoFields>
      </div>

      <div class="mb-5">
        <EventProducts
          :event="event"
          @refetch="$apollo.queries.event.refetch()"
        >
          <template #label>
            <h2 aria-hidden="true" />
          </template>
        </EventProducts>
      </div>

      <div class="my-5">
        <EventDocuments :event="event">
          <template #label>
            <h2 class="mb-2" style="font-size: 18px">
              {{
                $t(
                  "common:common.documents.label",
                  "Documents",
                  "Label of the documents section"
                )
              }}
            </h2>
          </template>
        </EventDocuments>
      </div>

      <div class="my-5">
        <EventContact :event="event">
          <template #label>
            <h2 style="font-size: 18px">
              {{
                $t(
                  "events:NonCompetitionEventPage.Schedule.contacts.heading",
                  "Organiser"
                )
              }}
            </h2>
          </template>
        </EventContact>
      </div>

      <div
        v-if="event.status == 'registration_open'"
        class="d-flex text-center justify-center"
        style="width: 100%"
      >
        <AppShowRegistrationBtn
          v-if="$vuetify.display.mdAndUp"
          :event="event"
        />
        <AppShowRegistrationBtn
          v-else
          max-width="295px"
          min-height="40px!important"
          width="100%"
          :event="event"
        />
      </div>
    </template>
  </v-container>
</template>
<script>
import gql from "fraql";
import AppLoadingPage from "@elements/AppLoadingPage.vue";
import EventProducts from "./EventProducts/index.vue";
import EventInfoFields from "./EventSchedule/EventInfoFields.vue";
import EventDocuments from "./EventSchedule/EventDocuments/index.vue";
import EventContact from "./EventSchedule/EventContact.vue";
import AppShowRegistrationBtn from "@AppShows/event/AppShowRegistrationBtn.vue";
import { useRouteScroll } from "@composables/route_scroll.ts";

export default {
  name: "NoncompetitionEventSchedule",
  components: {
    AppLoadingPage,
    EventProducts,
    EventInfoFields,
    EventDocuments,
    EventContact,
    AppShowRegistrationBtn
  },
  props: {
    eventId: {
      type: String,
      required: true
    }
  },
  setup() {
    const { scrollIntoElement } = useRouteScroll();
    return { scrollIntoElement };
  },
  data() {
    return {
      event: { id: null }
    };
  },
  apollo: {
    event: {
      query: gql`
        query nonCompetitionEventProfileSchedule($id: ID) {
          event(id: $id) {
            id
            status
            useOnlinePayments
            organiser {
              id
              hasVatObligation
            }
            allowedMutations
            ${AppShowRegistrationBtn.fragments.eventWithMutations}
            ${EventContact.fragments.contact}
            ${EventInfoFields.fragments.infoFields}
            ${EventProducts.fragments.eventProducts}
          }
        }
      `,
      variables() {
        return {
          id: this.eventId
        };
      },
      result({ loading }) {
        if (loading) return;
        this.scrollIntoElement();
      }
    }
  }
};
</script>
